const storeFrame = (
    video,
    context,
    canvas,
    resolve
) => {
    context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
    resolve(canvas.toDataURL("image/png", 1.0));
};

const getVideoFrame = async (
    video,
    context,
    canvas,
    time
) => {
    return new Promise(
        (resolve, reject) => {
            let eventCallback = () => {
                video.removeEventListener("seeked", eventCallback);
                storeFrame(video, context, canvas, resolve);
            };
            video.addEventListener("seeked", eventCallback);
            video.currentTime = time;
        }
    );
};

export const getFrame = async (videoUrl) => {
    return new Promise(
        (resolve, reject ) => {
            let frame = "";
            let canvas = document.createElement("canvas");
            let context = canvas.getContext("2d");

            let video = document.createElement("video");
            video.preload = "auto";
            video.crossOrigin = "anonymous";
            video.addEventListener("loadeddata", async function () {
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;

                frame = await getVideoFrame(video, context, canvas, 1);
                resolve(frame);
            });

            video.src = videoUrl;
            video.load();
        }
    );
};
